import Accesses from "@components/Collection/artist/Accesses";

export default Accesses;
